import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useEffect, useState } from "react";
import ButtonSelect from "../ButtonSelect";
import Pashto from "../Pashto";
import Phonetics from "../Phonetics";
import { concatPsString } from "../../lib/p-text-helpers";

function VerbInfoItemDisplay(_ref) {
  var item = _ref.item,
      textOptions = _ref.textOptions,
      tails = _ref.tails;

  var _useState = useState("long"),
      _useState2 = _slicedToArray(_useState, 2),
      length = _useState2[0],
      setLength = _useState2[1];

  var getL = function getL(x) {
    return "long" in x ? x[length] || x.short : x;
  };

  useEffect(function () {
    setLength(function (l) {
      return l === "mini" && !("mini" in item) ? "short" : l;
    });
  }, [item]); // const lengthsAvailable = "long" in item
  //     ? [...["long", "short"], ..."mini" in item ? ["mini"] : []] 
  //     : [];

  var text = getL(item);

  function addTails(text) {
    return concatPsString(text, {
      p: "ـ",
      f: "–"
    });
  }

  return _jsxs(_Fragment, {
    children: [Array.isArray(text) ? _jsxs("div", {
      children: [_jsxs("div", Object.assign({
        className: "text-center",
        dir: "rtl"
      }, {
        children: [_jsx(Pashto, Object.assign({
          opts: textOptions
        }, {
          children: text[0]
        }), void 0), _jsx("span", Object.assign({
          className: "mx-1"
        }, {
          children: " __ "
        }), void 0), _jsx(Pashto, Object.assign({
          opts: textOptions
        }, {
          children: tails ? addTails(text[1]) : text[1]
        }), void 0)]
      }), void 0), _jsxs("div", Object.assign({
        className: "text-center"
      }, {
        children: [_jsx(Phonetics, Object.assign({
          opts: textOptions
        }, {
          children: text[0]
        }), void 0), _jsx("span", Object.assign({
          className: "mx-1"
        }, {
          children: " __ "
        }), void 0), _jsx(Phonetics, Object.assign({
          opts: textOptions
        }, {
          children: tails ? addTails(text[1]) : text[1]
        }), void 0)]
      }), void 0)]
    }, void 0) : _jsxs("div", {
      children: [_jsx("div", Object.assign({
        className: "text-center"
      }, {
        children: _jsx(Pashto, Object.assign({
          opts: textOptions
        }, {
          children: tails ? addTails(text) : text
        }), void 0)
      }), void 0), _jsx("div", Object.assign({
        className: "text-center"
      }, {
        children: _jsx(Phonetics, Object.assign({
          opts: textOptions
        }, {
          children: tails ? addTails(text) : text
        }), void 0)
      }), void 0)]
    }, void 0), "long" in item && _jsx("div", Object.assign({
      className: "mt-2 text-center"
    }, {
      children: _jsx(ButtonSelect, {
        xSmall: true,
        options: [{
          label: "Long",
          value: "long"
        }, {
          label: "Short",
          value: "short"
        }].concat(_toConsumableArray("mini" in item ? [{
          label: "Mini",
          value: "mini"
        }] : [])),
        value: length,
        handleChange: function handleChange(p) {
          return setLength(p);
        }
      }, void 0)
    }), void 0)]
  }, void 0);
}

export default VerbInfoItemDisplay;